import React from 'react';
import styles from './iconHeading.module.css';
import { css } from '../../../services/css';

/**
 * @param {Object} props
 * @param {JSX.Element|string} props.children Title
 * @param {JSX.Element|null} [props.icon] Icon
 * @param {boolean} [props.iconBackground=true] Should the icon have a background
 */
export const IconHeading = ({children = <></>, icon = null, iconBackground = true}) => {

    return <h1 className={css(styles.IconHeading, iconBackground && styles.Background)}>
        {icon ? <div className='icon'>{icon}</div> : ''}
        {children}
    </h1>;
}